import { render, staticRenderFns } from "./MTrackingAppraisalMatrix.vue?vue&type=template&id=4c8e1f48&scoped=true&lang=pug&"
import script from "./MTrackingAppraisalMatrix.vue?vue&type=script&lang=js&"
export * from "./MTrackingAppraisalMatrix.vue?vue&type=script&lang=js&"
import style0 from "./MTrackingAppraisalMatrix.vue?vue&type=style&index=0&id=4c8e1f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e1f48",
  null
  
)

export default component.exports